var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alertStep',{attrs:{"useDefault":true,"useDefaultNumber":3}}),_vm._v(" "),_c('form-text-box',{ref:"schemeRentInfoBox",attrs:{"dataList":_vm.isGroup ? _vm.schemeRentInfo_group_formConfig : _vm.schemeRentInfo_formConfig,"rules":_vm.schemeRentInfo_formRule,"model":_vm.schemeRentInfo_model,"column":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }